import React, { useState } from 'react';
import { Linkedin, Twitter, Mail, ArrowRight } from 'lucide-react';

// Formsubmit.co — envío directo por email, sin backend cross-origin (iPad-safe)
const NEWSLETTER_ENDPOINT = 'https://formsubmit.co/ajax/info@tecnoabogado.com';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState('');

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(NEWSLETTER_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          Email: email,
          Origen: 'Newsletter — Tecnoabogado',
          _subject: 'Nueva suscripción newsletter Tecnoabogado',
          _template: 'table',
          _captcha: 'false',
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok && (data.success === 'true' || data.success === true)) {
        setNewsletterStatus('success');
        setEmail('');
      } else {
        throw new Error('Envío no válido');
      }
      setTimeout(() => setNewsletterStatus(''), 3000);
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      setNewsletterStatus('error');
      setTimeout(() => setNewsletterStatus(''), 3000);
    }
  };

  return (
    <footer className="bg-reset-dark border-t border-reset-gold/20">
      {/* Newsletter Section */}
      <div className="border-b border-reset-gold/20 py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl font-semibold text-white mb-2">
                Recibe contenido exclusivo sobre IA legal
              </h3>
              <p className="text-gray-400">
                Casos prácticos, herramientas y estrategias cada semana en tu inbox.
              </p>
            </div>
            <form onSubmit={handleNewsletterSubmit} className="flex gap-2 w-full md:w-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                required
                className="flex-1 md:w-64 bg-reset-black border border-reset-gold/30 text-white px-4 py-3 focus:outline-none focus:border-reset-gold transition-colors"
              />
              <button
                type="submit"
                className="bg-reset-gold hover:bg-reset-gold-light text-black px-6 py-3 font-semibold transition-all flex items-center gap-2"
              >
                Suscribirme
                <ArrowRight size={18} />
              </button>
            </form>
          </div>
          {newsletterStatus === 'success' && (
            <p className="text-green-400 text-sm mt-2 text-center md:text-right">
              ¡Gracias por suscribirte!
            </p>
          )}
          {newsletterStatus === 'error' && (
            <p className="text-red-400 text-sm mt-2 text-center md:text-right">
              Error al suscribirse. Inténtalo de nuevo.
            </p>
          )}
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <h3 className="text-2xl font-bold text-white mb-4" translate="no">
                <span className="text-reset-gold">Tecno</span>abogado
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                Programa de implementación de IA para despachos de abogados. Una colaboración entre RESET y <span translate="no">Tecnoabogado</span>.
              </p>
              <div className="text-sm text-gray-500 space-y-1 mb-4">
                <p><strong className="text-white">Luis López De Castro</strong></p>
                <p>Fundador de RESET</p>
                <a href="https://luislopezdecastroalonso.com/" target="_blank" rel="noopener noreferrer" className="text-reset-gold hover:underline block">luislopezdecastroalonso.com</a>
              </div>
              <div className="text-sm text-gray-500 space-y-1">
                <p><strong className="text-white">José Luis Vilaplana</strong></p>
                <p>@tecnoabogado</p>
                <a href="https://vilaplanatecnoabogado.es" target="_blank" rel="noopener noreferrer" className="text-reset-gold hover:underline block">vilaplanatecnoabogado.es</a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-white font-semibold mb-4">Servicios</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="#implementacion" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Implementación 1 a 1
                  </a>
                </li>
                <li>
                  <a href="#continuidad" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Continuidad
                  </a>
                </li>
                <li>
                  <a href="#contacto" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Consultoría puntual
                  </a>
                </li>
              </ul>
            </div>

            {/* Resources */}
            <div>
              <h4 className="text-white font-semibold mb-4">Recursos</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="#" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Blog
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Casos de éxito
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Biblioteca de prompts
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Preguntas frecuentes
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 className="text-white font-semibold mb-4">Legal</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="#" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Aviso legal
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Política de privacidad
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Política de cookies
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-reset-gold transition-colors">
                    Términos y condiciones
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-reset-gold/20 py-6">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>
              © {new Date().getFullYear()} Tecnoabogado by <a href="https://www.resetabogacia.com" target="_blank" rel="noopener noreferrer" className="text-reset-gold hover:underline">Reset</a> & <a href="https://www.iabogacia.com" target="_blank" rel="noopener noreferrer" className="text-reset-gold hover:underline">IABOGACIA</a>. Todos los derechos reservados.
            </p>
            <p className="text-gray-600 text-xs">
              Hecho con ❤️ para abogados innovadores
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;